import React from "react";
import { useAppSelector } from "hooks";
import { Icon, Tooltip } from "@slid/slid-ips";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import SmartLiveTextVideoNoteButtonIcon from "./SmartLiveTextVideoNoteButtonIcon";
import { useDesktopSLTButton } from "hooks/desktopSLT/useDesktopSLTButton";

const DesktopSmartLiveTextVideoNoteButton = () => {
  const { isSTTActive } = useAppSelector((state) => state.sttReducer);
  const { onMouseEnterSLTButton, onMouseLeaveSLTButton, onClickSLTButton, onClickSLTMoreButton, SLTButtonStatus, isSTTHovered, onMouseEnterSLTMoreButton, onMouseLeaveSLTMoreButton } =
    useDesktopSLTButton();
  const { t } = useTranslation(["VideoCaptureButton"]);

  return (
    <ButtonContainer onMouseEnter={onMouseEnterSLTButton} onMouseLeave={onMouseLeaveSLTButton} onClick={onClickSLTButton}>
      <SmartLiveTextVideoNoteButtonIcon isSTTHovered={isSTTHovered} SLTButtonStatus={SLTButtonStatus} />
      <ButtonText>
        {t(
          isSTTHovered && SLTButtonStatus !== "default"
            ? "StopSmartLiveText"
            : SLTButtonStatus === "default"
              ? "SmartLiveText"
              : SLTButtonStatus === "recording"
                ? "SmartLiveTextRecording"
                : SLTButtonStatus === "waiting"
                  ? "Waiting"
                  : "SmartLiveText"
        )}
      </ButtonText>
      <SettingButton onClick={onClickSLTMoreButton} onMouseEnter={onMouseEnterSLTMoreButton} onMouseLeave={onMouseLeaveSLTMoreButton}>
        <Tooltip title={t(isSTTActive ? "ShowSLTViewWhileSTTActive" : "ShowSLTView")} placement={"top"}>
          <div>
            <Icon icon={`chevronDown20`} color={`--gray17`} />
          </div>
        </Tooltip>
      </SettingButton>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.button`
  // S of reset button
  background: inherit;
  border: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  outline-style: none;
  padding: 0;
  position: relative;

  &:focus {
    outline: 0;
    border: none;
  }
  // E of reset button

  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  width: 64px;
  padding: 4px 0px;
  border-radius: 15px;
  cursor: pointer;

  &:hover {
    background-color: var(--gray3);
  }

  &:active {
    background-color: var(--gray2);
  }
`;

const ButtonText = styled.span`
  font-size: 1rem;
  line-height: 1.6rem;
  text-align: center;
  color: var(--gray17);
`;

const SettingButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 1px;
  top: 6px;
  width: 18px;
  height: 24px;
  border-radius: 8px;

  &:hover {
    background-color: var(--gray5);
  }
`;

export default DesktopSmartLiveTextVideoNoteButton;
